import { useLocale } from '@/i18n/locale';
import { cn } from '@/lib/utils';

/** The thin watched/total bar every Up next surface shares (`bg-ink` on `surface-alt`). */
export function UpNextProgress({
  name,
  watched,
  total,
  percent,
  className,
}: {
  name: string;
  watched: number;
  total: number;
  percent: number;
  className?: string;
}) {
  const { t } = useLocale();
  return (
    <div
      role="progressbar"
      aria-label={t('upnext.progressA11y', { title: name })}
      aria-valuemin={0}
      aria-valuemax={100}
      aria-valuenow={percent}
      aria-valuetext={t('upnext.progressOf', { watched, total })}
      className={cn('h-1 overflow-hidden rounded-full bg-surface-alt', className)}
    >
      <div className="h-full rounded-full bg-ink" style={{ width: `${percent}%` }} />
    </div>
  );
}

/**
 * The NEW status mark. `accent` on Tonight (the one documented amber
 * exception besides the next action); `neutral` (the ink inverse) on Library,
 * which has no amber (screens.md §`/library`).
 */
export function NewChip({ tone }: { tone: 'accent' | 'neutral' }) {
  const { t } = useLocale();
  return (
    <span
      className={cn(
        'rounded-sm px-1.5 text-micro',
        tone === 'accent' ? 'bg-accent text-on-accent' : 'bg-ink text-bg',
      )}
    >
      {t('upnext.new')}
    </span>
  );
}
